import(/* webpackMode: "eager" */ "/vercel/path0/client/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/call-rejected-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalModal"] */ "/vercel/path0/client/components/dialog/post-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/incoming-call-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StreamEndedModal"] */ "/vercel/path0/client/components/live-stream-end-modal-for-viewers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/loading-skeletons/router-loading-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrayerTimeNotifications"] */ "/vercel/path0/client/components/prayer-notification-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RingtonePlayer"] */ "/vercel/path0/client/components/ringtone-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/sockets-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/client/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/vercel/path0/client/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/components/wrapper-loader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"nato\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@1.7.4_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/sonner/dist/index.mjs");
